import { ContentfulClientApi, createClient } from 'contentful';

const environment =
  process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT_ID || 'master';

export const client = createClient({
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || '',
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN || '',
  environment,
});

export function previewClient(env: string | null = null): ContentfulClientApi {
  return createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || '',
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN || '',
    host: 'preview.contentful.com',
    environment: env || environment,
  });
}
